import React, { useState } from "react";
import Cookies from "js-cookie";
import CloseIcon from "@mui/icons-material/Close";
import styled from "@emotion/styled";

const Banner = styled.div`
  min-height: 30px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Instrument Sans";
  font-weight: 700;
  position: relative;
  font-size: 14px;

  ${({ $variant }) => $variant === "black" && `
    background-color: black;
    color: white;
    & a {
      color: white;
    }
  `}

  ${({ $variant }) => $variant === "white" && `
    background-color: white;
    color: black;
    border: 1px solid black;
    border-radius: 5px;
  `}

  ${({ $variant }) => $variant === "red" && `
    background-color: red;
    color: white;
    border-radius: 5px;
  `}
`;

const Actions = styled.div`
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 9px;
`

const DismissableBanner = ({ children, cookieName, variant = "black", dismissable = false }) => {
  const [isVisible, setIsVisible] = useState(!Cookies.get(cookieName));

  const handleClose = () => {
    Cookies.set(cookieName, "true", { expires: 1 });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Banner $variant={variant}>
      {children}

      {dismissable && (
        <Actions>
          <CloseIcon onClick={handleClose} style={{ fontSize: 14 }} />
        </Actions>
      )}
    </Banner>
  );
};


export default DismissableBanner;

